// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgPlayIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m19.9 10.29-14-7.08c-.62-.31-1.36-.28-1.95.08S3 4.3 3 4.99v14a2.01 2.01 0 0 0 2 2c.3 0 .61-.07.89-.21l14-6.93a1.996 1.996 0 0 0 .01-3.57Z" />
  </g>
);
export default SvgPlayIcon;
SvgPlayIcon.displayName = 'SvgPlayIcon';
